<template>
	<div class="inner">
		<slot />
	</div>
</template>
<style lang="scss">
@import "@assets/utils.scss";

.inner {
	width: 1200px;
	margin: 0 auto;
	padding: 0 15px;
	max-width: 100%;
	box-sizing: border-box;
	text-align: justify;
}

.entry-header h1:after {
	display: block;
	content: "";
	width: 60px;
	height: 3px !important;
	background: #1e3a8a !important;
	position: absolute;
	top: 0;
	left: 0;
}
.entry-title {
	font-family: Fira Sans;
	font-size: 50px;
	line-height: 1.3;
	font-weight: 700 !important;
	padding: 30px 0 0;
	margin-bottom: 24px;
	position: relative;
	margin-top: 35px;
}

.entry-content h2 {
	font-size: 24px !important;
	padding-bottom: 27px !important;
	padding-top: 0 !important;
	font-family: Rubik;
}

.entry-content p {
	font-family: Rubik;
	font-size: 16px;
	margin-bottom: 24px;
}

.entry-content a {
	text-decoration: none;
	color: #3fa9f5;
}

.entry-content ol,
.entry-content ul {
	margin-top: 0.8333333333em;
	margin-left: 1.3888888889em;
	padding-left: 0;
	font-size: 18px;
	font-weight: 300;
	font-family: Arial, Helvetica, sans-serif;
}

@media (max-width: 992px) {
	.inner {
		width: 100%;
		padding: 0 15px;
		text-align: left;
		max-width: auto;
		overflow-x: hidden;
	}

	.entry-header h1:after {
		display: none;
	}

	.entry-title {
		font-size: 24px;
		padding: 20px 0 0;
		margin-bottom: 24px;
		margin-top: 20px;
	}

	.entry-content h2 {
		font-size: 20px;
		padding-bottom: 20px;
		padding-top: 0;
	}

	.entry-content p {
		font-size: 16px;
		margin-bottom: 24px;
	}

	.entry-content ol,
	.entry-content ul {
		margin-top: 0.625em;
		margin-left: 1.25em;
		font-size: 16px;
		font-weight: 300;
	}

	.entry-content ul li {
		padding: 0 0 0 25px;
	}

	.entry-content ul li:before {
		width: 6px;
		height: 6px;
		top: 0.625em;
		margin-top: -3px;
	}

	.entry-content ol li {
		list-style: decimal;
	}

	.entry-content li {
		margin-bottom: 10px;
	}

	.entry-content li span {
		margin-bottom: 24px;
	}

	.have_bullets {
		width: 100%;
		max-width: none;
		margin-bottom: 24px;
		padding: 0 16px;
	}

	.have_bullets li:before {
		display: none;
	}

	.have_bullets p {
		font-size: 16px;
		padding: 10px 0;
	}

	.have_bullets a {
		white-space: normal;
		padding-right: 0;
	}
}

#toc_container {
	max-width: 640px;

	.toc_title {
		color: var(--base-white, #fff);
		font-family: Fira Sans;
		font-size: 20px;
		font-style: normal;
		font-weight: 700;
		line-height: 120%;
		margin-bottom: 0;
		display: inline-flex;
		gap: 12px;

		button {
			.expand {
				display: block;
			}

			.collapse {
				display: none;
			}

			&.active {
				.expand {
					display: none;
				}

				.collapse {
					display: block;
					visibility: visible;
				}
			}
		}
	}

	.toc_list {
		height: 0;
		overflow: hidden;
		transition: all 200ms ease-in-out;
		opacity: 0;

		&.active {
			height: 100%;
			margin-top: 16px;
			opacity: 1;
		}
		li {
			padding-left: 0;
		}
	}

	padding: 24px 16px;
	background-color: $primary-900;
	border-radius: 8px;

	margin-bottom: 32px;

	@include breakpoint(lg) {
		padding: 32px;
	}

	.toc_number {
		text-align: center;
		font-family: Rubik;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%;
		color: $primary-500;
		height: 20px;
		width: 20px;
		border-radius: 16px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		margin-right: 4px;
	}

	ul {
		padding-left: 0;
	}

	ul li {
		text-decoration: none;
		font-weight: 600;
		margin-bottom: 16px;

		&:last-child {
			margin-bottom: 0;
		}

		ul {
			margin-top: 16px;
			padding-left: 8px;

			li {
				font-weight: 400;
			}
		}
	}

	ul li::marker {
		content: "";
		display: none;
	}

	ul li a {
		color: white;
		font-family: Rubik;
		font-size: 18px;
		font-style: normal;
		line-height: 160%;
		margin-bottom: 12px;

		&:hover {
			text-decoration: underline;
		}

		/* 29.6px */
	}
}
</style>
